import type { Vault } from '@/types/vault'
import { getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

const advancedAnalyticsCompositionQueryKey = ['advancedAnalyticsComposition'] as const

interface AdvancedAnalyticsCompositionQueryParams {
  network: Vault['network']['name']
  vaultId: Vault['vaultId']
  enabled?: boolean
}

function advancedAnalyticsCompositionQueryOptions({
  network,
  vaultId,
  enabled = true,
}: AdvancedAnalyticsCompositionQueryParams) {
  return queryOptions({
    queryKey: [...advancedAnalyticsCompositionQueryKey, { network, vaultId }] as const,
    queryFn() {
      const internalAppSdk = getInternalAppSdk()
      return internalAppSdk.getAdvancedAnalytics({ network, vaultId, select: { composition: true } })
    },
    enabled,
    retry: 2,
    staleTime: 10 * MINUTE_IN_MILLISECONDS,
  })
}

export function useAdvancedAnalyticsCompositionQuery(params: AdvancedAnalyticsCompositionQueryParams) {
  return useQuery(advancedAnalyticsCompositionQueryOptions(params))
}
